// src/app/app.routes.ts
import { Routes }                         from '@angular/router';
import { ShellComponent }                 from './layout/shell.component';
import { MainPageComponent }              from './pages/mainPage/mainPage.component';
import { TransactionDetailComponent }     from './pages/transactionsPages/transactionDetailPage/transactionDetail.component';
import { SettingsPageComponent }            from  './pages/settingsPage/settingsPage.component';
import { MessageDetailPageComponent } from './pages/messagesPages/messageDetailPage/messageDetailPage.component';
import { ChartDetailPageComponent } from './pages/chartsPages/chartDetailPage/chartDetailPage.component';
import { TableDetailPageComponent } from './pages/tablePages/tableDetailPage/tableDetailPage.component';
import { MessagesMainPageComponent } from './pages/messagesPages/messagesMainPage/messagesMainPage.component';
import { ChartMainPageComponent } from './pages/chartsPages/chartMainPage/chartMainPage.component';
import { TableMainPageComponent } from './pages/tablePages/tableMainPage/tableMainPage.component';
import { TransactionMainPageComponent } from './pages/transactionsPages/transactionMainPage/transactionMainPage.component';

export const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: '',
        component: MainPageComponent,
        data: { title: 'MAINPAGE.TITLE' }
      },
      {
        path: 'settings',
        component: SettingsPageComponent,
        data: { title: 'SETTINGS.TITLE' }
      },
      {
        path: 'message', 
        component: MessagesMainPageComponent,
        data: { title: 'MESSAGES.TITLE' }
      },
      {
        path: 'message/detail/:id', 
        component: MessageDetailPageComponent,
        data: { title: 'MESSAGES.TITLE' }
      },
      {
        path: 'chart', 
        component: ChartMainPageComponent,
        data: { title: 'CHARTS.TITLE' }
      },
      {
        path: 'chart/detail/:id',
        component: ChartDetailPageComponent,
        data: { title: 'CHARTS.TITLE' }  
      },
      {
        path: 'table',
        component: TableMainPageComponent,
        data: { title: 'TABLES.TITLE' }
      },
      {
        path: 'table/detail/:id',
        component: TableDetailPageComponent,
        data: { title: 'TABLES.TITLE' }
      },
      {
        path: 'transaction',
        component: TransactionMainPageComponent,
        data: { title: 'TRANSACTION.MAIN_TITLE' }
      },
      {
        path: 'transaction/detail/:id',
        component: TransactionDetailComponent,
        data: { title: 'TRANSACTION.TITLE' }
      }
    ]
  },
  { path: '**', redirectTo: '' }
];
